
// Combined data for all utilities
export const combinedData = [
  { name: 'Jan', electricity: 250, gas: 120, water: 80 },
  { name: 'Feb', electricity: 260, gas: 130, water: 85 },
  { name: 'Mar', electricity: 270, gas: 110, water: 90 },
  { name: 'Apr', electricity: 280, gas: 90, water: 95 },
  { name: 'May', electricity: 300, gas: 80, water: 100 },
  { name: 'Jun', electricity: 320, gas: 70, water: 110 },
  { name: 'Jul', electricity: 350, gas: 60, water: 120 },
  { name: 'Aug', electricity: 330, gas: 65, water: 115 },
  { name: 'Sep', electricity: 320, gas: 75, water: 110 },
  { name: 'Oct', electricity: 290, gas: 90, water: 100 },
  { name: 'Nov', electricity: 300, gas: 110, water: 95 },
  { name: 'Dec', electricity: 320, gas: 120, water: 90 },
];
